import { render, staticRenderFns } from "./policy-documents.vue?vue&type=template&id=aee03172"
import script from "./policy-documents.vue?vue&type=script&lang=js"
export * from "./policy-documents.vue?vue&type=script&lang=js"
import style0 from "./policy-documents.vue?vue&type=style&index=0&id=aee03172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports